import { Product2Schema } from "@redotech/redo-model/inventory/inventory";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getProducts = unaryRpc({
  name: "getProducts" as const,
  input: z.object({
    page: z.number().min(1).default(1),
    pageSize: z.number().min(1).max(100).default(20),
  }),
  output: z.object({
    products: z.array(Product2Schema),
    totalCount: z.number(),
    page: z.number(),
    pageSize: z.number(),
  }),
});
